module.exports = __webpack_public_path__ + "img/party-icon.8d526886.svg";